import { useState } from "react";
//import svgPaths from "../../imports/Icon/svg-sta87c9gdb";

interface EmailValueCardProps {
  variant?: "post-result" | "standalone";
  onEmailSent?: (email: string, name: string) => void;
}


export function EmailValueCard({ variant = "post-result", onEmailSent }: EmailValueCardProps) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [nameFocused, setNameFocused] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [consent, setConsent] = useState(false);

  const handleSubmit = () => {
    if (name.trim() && email.includes("@")) {
      onEmailSent?.(name, email);
    }
  };

  return (
    <div className="rounded-2xl border border-[#F3D2BE] overflow-hidden" style={{ backgroundColor: 'rgba(251, 241, 234, 0.4)' }}>
      {/* Header */}
      <div className="px-6 pt-6 pb-5">
        <div className="mb-5">
          <span className="inline-block text-[11px] font-bold uppercase tracking-[1.2px] text-[#d76f2c] mb-2">Adgang</span>
          <h3 className="text-[17px] font-bold text-[#1a1a1a]">Få adgang til din personlige lønside og</h3>
        </div>

        {/* Benefits checklist */}
        <div className="space-y-2.5 mb-6">
          <BenefitItem title="Forstå, hvad din løn reelt dækker" />
          <BenefitItem title="Se hvilke vilkår der typisk følger med dit lønniveau" />
          <BenefitItem title="Få konkrete råd til din næste lønsamtale" />
          <BenefitItem title="Se hvad du realistisk kan forvente – og hvornår det giver mening" />
        </div>

        {/* Name and Email inputs */}
        <div className="space-y-3">
          {/* Name input */}
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onFocus={() => setNameFocused(true)}
            onBlur={() => setNameFocused(false)}
            placeholder="Dit navn"
            style={{ marginBottom: "8px" }}
            className={`w-full py-3.5 px-4 rounded-lg transition-all duration-200 text-[15px] text-[#333] placeholder:text-gray-400 focus:outline-none bg-white ${
              name
                ? "border-2 border-[#F3D2BE]"
                : nameFocused
                  ? "border-2 border-[#F3D2BE]"
                  : "border border-[#F3D2BE]"
            }`}
          />

          {/* Email input */}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setEmailFocused(true)}
            onBlur={() => setEmailFocused(false)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            placeholder="Din e-mail"
            style={{ marginBottom: "8px"}}
            className={`w-full py-3.5 px-4 rounded-lg transition-all duration-200 text-[15px] text-[#333] placeholder:text-gray-400 focus:outline-none bg-white ${
              email
                ? "border-2 border-[#F3D2BE]"
                : emailFocused
                  ? "border-2 border-[#F3D2BE]"
                  : "border border-[#F3D2BE]"
            }`}
          />

          {/* Consent checkbox */}
          <div style={{ display: "flex", alignItems: "top", marginBottom: "24px", marginTop: "8px" }}>
            <input
              type="checkbox"
              id="acceptContact"
              checked={consent}
              onChange={e => setConsent(e.target.checked)}
              className="customCheckbox"
            />
            <span className="checkmark"></span>
            <label htmlFor="acceptContact" style={{ fontSize: "12px", color: "#333", cursor: "pointer", width: "90%" }}>
              Ja tak til nyheder, gyldne guides og gode tilbud fra Ase og vores <a target="_blank" href="https://www.ase.dk/gdpr/ase-a-kasse-samarbejdspartnere" style={{ textDecoration: "underline" }}>fordelspartnere</a> på e-mail om karriere, løn, økonomi og forsikring.
            </label>
          </div>

          <button
            onClick={handleSubmit}
            disabled={!name.trim() || !email.includes("@") || !consent}
            style={{ marginBottom: "8px"}}
            className="button w-full py-3.5 rounded-[40px] text-base lg:text-[17px] font-bold text-white bg-[#D76F2C] hover:bg-[#c15f1f] disabled:opacity-40 disabled:cursor-not-allowed transition-all active:scale-[0.98] cursor-pointer"
          >
            Få adgang
          </button>
        </div>

        <a target="_blank" href="https://www.ase.dk/cookie-privatliv-og-persondata" className="text-[#9b9b9a] mt-3 text-center leading-relaxed" style={{ display: "flex", justifyContent: "center", marginTop: "0px", color: "#9b9b9a", textAlign: "center", fontSize: "12px", textDecoration: "underline" }}>
          Sådan behandler vi dine personlige oplysninger
        </a>
      </div>
    </div>
  );
}

function BenefitItem({ title }: { title: string }) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="w-4 h-4 shrink-0">
        <svg className="w-full h-full" fill="none" viewBox="0 0 16 16">
          <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#D76F2C" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
        </svg>
      </div>
      <span className="text-[14px] text-[#3a3a39]">{title}</span>
    </div>
  );
}